import React from 'react'

interface LogoMobileProps {
  logo: string,
  handleMenuSelection: any,
}
declare const window: any;

const LogoProyectoMobile = ({logo, handleMenuSelection}: LogoMobileProps) => {
  return(
    <div className='logo-proyecto-container-mobile' onClick={() => {handleMenuSelection('')}} style={{cursor: 'pointer'}}>
      <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+logo} alt=""></img>
    </div>
  )
}

export default LogoProyectoMobile